import { pipe } from 'fp-ts/lib/function';
import * as TE from 'fp-ts/lib/TaskEither';

import StudyApi from '../api/StudyApi';
import type { CardHtml } from '../model/domain/CardHtml';
import type { Deck, DeckCard, ResourcesItem } from '../model/domain/Deck';
import type { StudyCard, StudyCardReply, StudySession } from '../model/domain/StudySession';
import type { BSError } from '../model/error/BSError';
import type { BSTask } from '../model/types';

const getUserLibraryDecks = (): BSTask<Deck[]> => {
  return pipe(StudyApi.getUserLibraryDecks());
};

const getUserLibraryDeckCards = (deckId: string): BSTask<DeckCard[]> => {
  return pipe(StudyApi.getUserLibraryDeckCards(deckId));
};

const getUserLibraryCard = (cardId: string): BSTask<CardHtml> => {
  return pipe(StudyApi.getUserLibraryCard(cardId));
};

const getUserLibraryResources = (): BSTask<ResourcesItem[]> => {
  return pipe(StudyApi.getUserLibraryResources());
};

const getStudySession = (): BSTask<StudySession | null> => {
  const maybeStartSession = (session: StudySession | null): TE.TaskEither<BSError, StudySession | null> =>
    session ? TE.right<BSError, StudySession | null>(session) : StudyApi.startStudySession();

  // TODO: Uncomment this when you want to delete the session and start a new one
  // return pipe(
  //   StudyApi.deleteStudySession(),
  //   TE.chain(() => StudyApi.getStudySession()),
  //   TE.chain(maybeStartSession)
  // );

  return pipe(StudyApi.getStudySession(), TE.chain(maybeStartSession));
};

const postFinishStudySession = (): BSTask<StudySession | null> => {
  return pipe(StudyApi.finishStudySession());
};

const postAnswerGetNextCard = (reply: StudyCardReply | null): BSTask<StudyCard | null> => {
  return pipe(StudyApi.postAnswerGetNextCard(reply));
};

export default {
  getStudySession,
  getUserLibraryCard,
  getUserLibraryDeckCards,
  getUserLibraryDecks,
  getUserLibraryResources,
  postAnswerGetNextCard,
  postFinishStudySession,
};
